import React from 'react'
import './style.css'

class PersonItem extends React.Component {
  render() {
    const { displayTags, displayTitle, thumbnailImage, item: { tags, gist: { firstName, lastName } }} = this.props
    return <a href={this.props.item.permalink} className="tray-person-item">
        <div className="image-container">
          <div className="image" style={{ backgroundImage: `url(${thumbnailImage ? thumbnailImage : "https://www.synergy-learning.com/wp-content/uploads/2018/02/default-1.jpg"})` }}>
          {
          	displayTags && (
				<div className="details inline">
				{
					tags.map(tag => (
							<span className="title" key={tag.id}>
								{tag.title}
							</span>
					))
				}
				</div>
          	)
          }
          </div>
        </div>
		{
			displayTitle && (
			<div className="details bottom">
				<p className="title">
					{firstName} {lastName}
				</p>
			</div>          		
			)
		}
      </a>;
  }

}

export default PersonItem;